import { VoucherStatus, VoucherType } from '../../models/vouchers';

export const getCustomerVouchers = (
  vouchers: any[],
  siteId: number,
  phoneNumber: string
) => {
  const matchedVouchers = vouchers.filter(
    (voucher) =>
      voucher.siteId === siteId &&
      voucher.customerPhoneNumber === phoneNumber &&
      voucher.status !== VoucherStatus.CANCELED
  ).sort((a, b) => b.id - a.id);

  const proVoucher = matchedVouchers.find(
    (v) => v.type === VoucherType.SBSubscription
  );
  const mailBoxVoucher = matchedVouchers.find(
    (v) => v.type === VoucherType.UpgradeToSmartLocker
  );

  return {
    matchedVouchers,
    proVoucher,
    mailBoxVoucher,
  };
};
